// Compressed plan state for the URL hash. Uses web globals (CompressionStream,
// btoa/atob, Response) — available in the browser and in Node 24 (so Vitest runs it).

export function bytesToB64url(bytes: Uint8Array): string {
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function b64urlToBytes(s: string): Uint8Array {
  s = s.replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  const bin = atob(s);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return arr;
}

async function gzip(str: string): Promise<Uint8Array> {
  const stream = new Response(str).body!.pipeThrough(new CompressionStream("gzip"));
  return new Uint8Array(await new Response(stream).arrayBuffer());
}

async function gunzip(bytes: Uint8Array): Promise<string> {
  // `as BodyInit`: a Uint8Array is a valid body at runtime; the cast sidesteps the
  // TS 5.7 typed-array generic mismatch between the DOM and Node lib definitions.
  const stream = new Response(bytes as BodyInit).body!.pipeThrough(new DecompressionStream("gzip"));
  return new Response(stream).text();
}

// tag the payload: "g" = gzipped, "r" = raw (fallback when streams unavailable)
export async function encodeState(obj: unknown): Promise<string> {
  const json = JSON.stringify(obj);
  if (typeof CompressionStream !== "undefined") return "g" + bytesToB64url(await gzip(json));
  return "r" + bytesToB64url(new TextEncoder().encode(json));
}

export async function decodeState(str: string): Promise<any> {
  const bytes = b64urlToBytes(str.slice(1));
  const json = str[0] === "g" ? await gunzip(bytes) : new TextDecoder().decode(bytes);
  return JSON.parse(json);
}
